import '@ngrx/core/add/operator/select';
import 'rxjs/add/operator/map';
import {
  Component,
  OnDestroy,
  ChangeDetectionStrategy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, ParamMap, Params, Router } from '@angular/router';
import { Store } from '@ngrx/store';

import * as fromRoot from '../reducers';
import * as jobActions from '../actions/jobs.actions';
import * as listingActions from '../actions/listing.actions';
import { switchMap, map, take } from 'rxjs/operators';
import { LoadJobProcess } from '../edit-job-tpl-process/actions/process.actions';
import { LoadJobSourcing } from '../../job-sourcing-module/actions/job-sourcing.actions';
import {
  LoadJobAssignments,
  JobsActions,
  RequestToLoadJobAssignments,
} from '../actions/jobs.actions';
import { SelectedJobPageComponent } from './selected-job-page.component';
import { MatDialog } from '@angular/material';
import { JobPostCanDeactivateGuard } from '../../lib/services/routeGuard';
import { ConfirmationDialogComponent } from '../../shared-module/components/mj-confirmation-dialog/confirmation-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { NavigationStore } from '../../lib/stores/navigationStore/navigationStore';

@Component({
  selector: 'mj-view-job-page',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <mj-selected-job-page></mj-selected-job-page>
  `,
})
export class ViewJobPageComponent implements OnDestroy, OnInit {
  @ViewChild(SelectedJobPageComponent, { static: false })
  child: SelectedJobPageComponent;
  actionsSubscription$: any;

  constructor(
    public store: Store<fromRoot.State>,
    public route: ActivatedRoute,
    public router: Router,
    public dialog: MatDialog,
    private translate: TranslateService,
    private navStore: NavigationStore,
    private _jobPostCanDeactivateGuard: JobPostCanDeactivateGuard
  ) {}

  ngOnInit() {
    this.actionsSubscription$ = this.route.params.subscribe(
      (params: Params) => {
        let id = params['id'];
        if (!id) {
          const routeArr = this.router.url.split('/');
          id = Number(routeArr[routeArr.length - 2]);
        }
        this.store.dispatch(new jobActions.LoadJob({ jobId: id }));
        this.store.dispatch(new jobActions.LoadJobCategories());
        this.store.dispatch(new LoadJobProcess({ jobId: id }));
        this.store.dispatch(new listingActions.LoadListing({ jobId: id }));
        this.store.dispatch(new LoadJobSourcing({ jobId: id }));
        this.store.dispatch(new LoadJobAssignments({ jobId: id }));
      }
    );
    this.translate
      .get('post_job_post_title')
      .pipe(take(1))
      .subscribe(text => {
        this.navStore.setCurrentComponent(text);
      });
  }

  ngOnDestroy() {
    this.actionsSubscription$.unsubscribe();
  }

  public get isJobSaved() {
    // TODO make it better!
    return this.child.child.selectedJobInfoComponent.isJobSaved;
  }

  public openDiscardChangesModal(): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '600px',
      data: {},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        switch (result) {
          case 'save':
            this.store.dispatch(new jobActions.SaveCurrentJobState());
            return this._jobPostCanDeactivateGuard.discard();
          case 'exit':
            return this._jobPostCanDeactivateGuard.discard();
          default:
            return this._jobPostCanDeactivateGuard.discard();
        }
      }
    });
  }
}
